<template>
    <div class="main555555555">
        <iframe id="1" :src="dtssrc" width="100%" height="100%" scrolling="no" frameborder="0" />
    </div>
</template>

<script>
export default {
    data() {
        return {
            dtssrc: ''
            // menuList: sessionStorage.getItem('selfMenu').split(','),
            // downloadData:[],
            // time:'',
        };
    },
    // watch:{
    //     downloadData(nval,oval){
    //       let data = this.getcomplement(nval,oval) || []
    //       if(data.length) {
    //             data.forEach((item,index)=>{
    //                 this.$notify({
    //                     title: '提示',
    //                     message: `${item.fileName}可导出` ,
    //                     duration: 2000,
    //                     type: 'success'
    //                 });
    //             })
    //         }
    //     }
    // },
    created() {
        this.getDts();
        // this.init();
    },
    beforeDestroy() {
        // clearInterval(this.time)
    },
    methods: {
        getSelfMenu() {
            // this.$http.get(this.$service.main.getslefMenu).then(res => {
            //     this.dtssrc = res.data.dts[0].url || '';
            // });
        },
        getDts() {
            this.$http.get(this.$service.main.queryIndex).then(res => {
                this.dtssrc = res.data[0].url || '';
            });
        },
        init() {
            const that = this;
            this.time = setInterval(function () {
                that.getData();
            }, 20000);
        },
        getcomplement(arr1, arr2) {
            if (!arr1 || !arr2) {
                return [];
            }
            return arr2.filter(temp => arr1.map(s => s.id).indexOf(temp.id) === -1);
        },
        getData() {
            if (!this.menuList.includes('export_file')) {
                return false;
            }
            let data = {};
            data.pageNum = 1;
            data.pageSize = 9999;
            data.type = '';
            this.$http.get(this.$service.comprehensiveQuery.exportFileManagement.getTableData, { params: data }).then(res => {
                if (res.message === '查询成功' || res.message === 'ok') {
                    this.downloadData = res.data.rows.filter(s => s.status !== 'copy') || [];
                    if (this.downloadData.length === 0) {
                        clearInterval(this.time);
                    }
                } else {
                    clearInterval(this.time);
                }
            });
        }
    }
};
</script>
<style>
.test333 {
	height: 98%;
}
iframe {
	width: 100%;
	height: 100%;
}
</style>
